module.exports = __webpack_public_path__ + "img/54.2655234b.jpg";